module.exports = __webpack_public_path__ + "img/element_bulle.700feb15.svg";